import React, { useRef, useEffect, useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  ImageListItem,
  Stack,
  Grid,
} from "@mui/material";
import iphoneOne from "./assets/iphone/iphone_1.png";
import iphoneFour from "./assets/iphone/iphone_2.png";
import iphoneFive from "./assets/iphone/iphone_3.png";
import iphoneSix from "./assets/iphone/iphone_4.png";
import iphoneEight from "./assets/iphone/iphone_6.png";
import iphoneNine from "./assets/iphone/iphone_7.png";
import iphoneTen from "./assets/iphone/iphone_8.png";

import { Divider } from "@mui/material";
import { useLocation } from "react-router-dom";
import training from "./assets/android/training.png";

import {
  ChevronLeft,
  ChevronRight,
  FiberManualRecord,
} from "@mui/icons-material";
import Footer from "./footer";

const IOSTraining = () => {
  const scrollRef = useRef();
  const { pathname } = useLocation();

  const images = [iphoneNine, iphoneFour, iphoneFive, iphoneSix, iphoneTen];

  const indexRef = useRef(0);
  const [activeIndex, setActiveIndex] = useState(0);

  const scrollToIndex = (index) => {
    const width = scrollRef.current.offsetWidth;
    scrollRef.current.scrollTo({
      left: index * width,
      behavior: "smooth",
    });
    setActiveIndex(index);
  };

  const handleManualScroll = (direction) => {
    const newIndex =
      (indexRef.current + direction + images.length) % images.length;
    indexRef.current = newIndex;
    scrollToIndex(newIndex);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    const interval = setInterval(() => {
      indexRef.current = (indexRef.current + 1) % images.length;
      scrollToIndex(indexRef.current);
    }, 3000); // every 3 seconds

    return () => clearInterval(interval); // cleanup on unmount
  }, []);

  return (
    <Box>
      <Box maxWidth="100%">
        <Box
          sx={{
            position: "relative",
            minHeight: { xs: "50vh", md: "50vh" },
            backgroundImage: `url(${iphoneOne})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            px: 2,
            flexDirection: "column",
            textAlign: "center",
            overflow: "hidden",
          }}
        >
          {/* Blurred Overlay */}
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              backgroundColor: "rgba(0, 0, 0, 0.4)",
              backdropFilter: "blur(2px)",
              zIndex: 1,
            }}
          />

          {/* Text Content */}
          <Box sx={{ maxWidth: "auto", mb: 4, zIndex: 2 }}>
            <Typography
              variant="h3"
              gutterBottom
              sx={{ color: "white", fontWeight: 700 }}
            >
              iOS App Training
            </Typography>
          </Box>
        </Box>
      </Box>

      <Grid
        container
        spacing={4}
        alignItems="top"
        justifyContent="center"
        sx={{ flexWrap: "wrap", mt: 5 }}
      >
        {/* Left: Image */}

        <Grid item sx={{ width: { xs: "100%", md: "40%" } }}>
          <Box
            sx={{
              pl: { xs: 2, md: 0 },
              pr: { xs: 2, md: 0 },
              mb: { xs: 0, md: 2 },
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                color: "orange",
                textAlign: "left",
                pb: { xs: 2, md: 2 },
              }}
            >
              iOS App Training
            </Typography>
            <Typography variant="body1" paragraph>
              iOS app training equips learners with the knowledge and skills
              required to build applications for Apple devices such as iPhones,
              iPads, and Apple Watch. Our training program is designed to start
              from the ground up, making it accessible even for beginners with
              no prior coding experience. We cover the fundamentals of Swift—the
              powerful and intuitive programming language used for Apple
              development—along with Xcode, Apple’s official integrated
              development environment. Students learn about the structure of iOS
              apps, interface design using SwiftUI and Storyboards, app
              lifecycle, and how to build user-friendly interfaces that meet
              Apple’s design guidelines.
            </Typography>

            <Typography variant="body1" paragraph>
              As the training progresses, learners are introduced to advanced
              topics such as Core Data, networking using URLSession, API
              integration, data persistence, and real-time communication using
              Firebase. We also focus on concepts like MVC and MVVM
              architecture, app optimization, and debugging techniques to help
              students build scalable, secure, and high-performing apps. The
              curriculum includes hands-on projects such as creating to-do apps,
              chat applications, e-commerce prototypes, and more. These
              real-world assignments not only reinforce theoretical knowledge
              but also give students a portfolio to showcase to potential
              employers.
            </Typography>

            <Typography variant="body1" paragraph>
              Our training goes beyond just coding. It prepares you for App
              Store deployment, helping you understand Apple’s app review
              process, provisioning profiles, and TestFlight for beta testing.
              Additionally, we offer interview preparation, resume building
              sessions, and one-on-one mentorship from experienced iOS
              developers. Whether your goal is to land a job, freelance, or
              launch your own app, our iOS training provides the end-to-end
              support you need to succeed in the competitive mobile development
              space.
            </Typography>
          </Box>
        </Grid>

        <Grid item sx={{ width: { xs: "100%", md: "35%" } }}>
          <Box
            flex={1}
            maxHeight="800px"
            overflow="auto"
            borderLeft="1px solid #ccc"
            sx={{ pl: { xs: 0, md: 2 } }}
          >
            <Box>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                sx={{
                  maxWidth: "100%",
                  mx: "auto",
                  overflow: "hidden",
                  mt: { xs: 0, md: 4 },
                }}
              >
                <IconButton onClick={() => handleManualScroll(-1)}>
                  <ChevronLeft />
                </IconButton>

                <Box
                  ref={scrollRef}
                  sx={{
                    width: { xs: "100%", md: 600 },
                    height: { xs: "100%", md: 500 },
                    display: "flex",
                    overflowX: "hidden",
                    scrollSnapType: "x mandatory",
                  }}
                >
                  {images.map((src, index) => (
                    <ImageListItem
                      key={index}
                      sx={{
                        flex: "0 0 100%",
                        scrollSnapAlign: "center",
                      }}
                    >
                      <img
                        src={src}
                        alt={`Slide ${index + 1}`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: "16px", // Adjust as needed (e.g., 8px, 24px)
                        }}
                        loading="lazy"
                      />
                    </ImageListItem>
                  ))}
                </Box>

                <IconButton onClick={() => handleManualScroll(1)}>
                  <ChevronRight />
                </IconButton>
              </Box>

              {/* Indicators */}
              <Stack
                direction="row"
                justifyContent="center"
                mt={2}
                sx={{ mt: 5 }}
              >
                {images.map((_, index) => (
                  <IconButton
                    key={index}
                    size="small"
                    onClick={() => scrollToIndex(index)}
                  >
                    <FiberManualRecord
                      fontSize="small"
                      color={index === activeIndex ? "primary" : "disabled"}
                    />
                  </IconButton>
                ))}
              </Stack>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Divider sx={{ my: 1, borderColor: "orange", mt: 5 }} />

      <Box sx={{ width: { xs: "100%", md: "80%" }, mx: "auto", mb: 5 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center", // centers horizontally
            px: 2,
            mt: 5,
          }}
        >
          <Box>
            <Typography
              variant="h4"
              sx={{ color: "orange", fontWeight: "bold", mb: 1 }}
            >
              Why should you learn iOS?
            </Typography>

            <Typography variant="body1" sx={{ mb: 2 }}>
              Learning iOS development opens the door to building
              high-performance apps for one of the most profitable mobile
              ecosystems in the world. Apple users are known for their high
              engagement and spending power, making iOS apps a lucrative avenue
              for developers and businesses alike. By mastering iOS, you gain
              access to a global market of millions of users on iPhones, iPads,
              Apple Watches, and Apple TVs. With the growing demand for iOS apps
              across industries—from health and finance to education and
              entertainment—skilled developers are in high demand, offering
              strong career opportunities and high salaries.
            </Typography>

            <Typography variant="body1" sx={{ mb: 1 }}>
              Additionally, iOS development provides a streamlined,
              developer-friendly environment supported by Apple’s robust tools
              and documentation. With languages like Swift and development tools
              like Xcode, Apple offers a stable, consistent platform with fewer
              device variations compared to Android. This allows developers to
              focus more on innovation and performance rather than compatibility
              issues. Whether you're aiming to work for top tech companies,
              launch your own startup, or freelance with premium clients,
              learning iOS development is a smart and future-proof investment in
              your tech career.
            </Typography>
          </Box>
        </Box>

        {/* Centered small orange line */}
        <Divider
          sx={{
            width: 60,
            mx: "auto",
            borderBottom: "3px solid orange",
            mb: 4,
          }}
        />

        {/* Content Block: Image Left, Text Right */}
        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{ flexWrap: "wrap", pl: { xs: 2, md: 0 }, pr: { xs: 2, md: 0 } }}
        >
          {/* Left: Image */}
          <Grid item sx={{ width: { xs: "100%", md: "40%" } }}>
            <img
              src={iphoneTen}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>

          {/* Right: Text */}
          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Why Learn iOS App Development from us?
            </Typography>
            <Typography variant="body1">
              At our training center, we combine expert-led instruction with
              real-world application to ensure you gain practical and in-demand
              iOS development skills. Our curriculum is designed by experienced
              developers who understand what the tech industry looks for in
              candidates. From mastering Swift and Xcode to working on live
              projects, we equip you with everything you need to build
              functional, user-friendly, and App Store-ready applications. We
              emphasize hands-on training, ensuring you're not just learning
              theory, but actually building and testing real iOS apps that
              mirror current market standards. What sets us apart is our
              commitment to your career success. We provide one-on-one
              mentorship, industry insights, interview preparation, and job
              placement support to help you transition smoothly from training to
              employment. Our instructors are professionals with years of iOS
              development experience, ready to guide you through both
              foundational concepts and the latest Apple technologies like
              SwiftUI, ARKit, and watchOS. Whether you're a student, graduate,
              or a professional switching careers, our program is tailored to
              get you job-ready with zero fluff and maximum relevance.
            </Typography>
          </Grid>
        </Grid>

        <Divider
          sx={{
            width: 60,
            mx: "auto",
            borderBottom: "3px solid orange",
            mb: 4,
          }}
        />
        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{ flexWrap: "wrap", pl: { xs: 2, md: 0 }, pr: { xs: 2, md: 0 } }}
        >
          {/* Left: Image */}

          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Zero Investment iOS Training
            </Typography>
            <Typography variant="body1">
              Our Zero Investment iOS Training program is designed to eliminate
              financial barriers so that anyone passionate about app development
              can kickstart their career. You don’t need to pay anything upfront
              — we believe in outcome-based learning where you invest only after
              achieving success. This means you focus purely on learning and
              skill development without worrying about course fees. Once you
              secure a full-time job in the industry, only then are you expected
              to contribute, making this model risk-free and highly accessible.
            </Typography>
          </Grid>

          <Grid item sx={{ width: { xs: "100%", md: "25%" } }}>
            <img
              src={iphoneNine}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>
        </Grid>

        <Divider
          sx={{
            width: 60,
            mx: "auto",
            borderBottom: "3px solid orange",
            mb: 4,
          }}
        />

        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{
            flexWrap: "wrap",
            pb: { xs: 2, md: 0 },
            pl: { xs: 2, md: 0 },
            pr: { xs: 2, md: 0 },
          }}
        >
          {/* Left: Image */}
          <Grid item sx={{ width: { xs: "100%", md: "40%" } }}>
            <img
              src={iphoneEight}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>

          {/* Right: Text */}
          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Comprehensive iOS Training
            </Typography>
            <Typography variant="body1">
              Our Comprehensive iOS Training program is meticulously crafted to
              cover every essential aspect of iOS app development — from the
              fundamentals to advanced features. Whether you're new to app
              development or looking to enhance your existing skills, our
              curriculum includes everything you need: Swift programming
              language, Xcode IDE, UIKit, SwiftUI, Core Data, and real-world
              integration of APIs. We guide you step-by-step through the entire
              app lifecycle — from UI design to debugging, testing, and
              deployment to the App Store.
            </Typography>

            <Typography variant="body1" sx={{ mt: 1 }}>
              What sets our training apart is its hands-on approach. You'll work
              on live projects and practical assignments that simulate real
              industry tasks, helping you gain confidence and problem-solving
              skills. Our modules are regularly updated to reflect the latest
              tools and trends in the iOS ecosystem, including new iOS versions,
              Apple Silicon, and updated design standards. With this
              comprehensive training, you'll be fully equipped to build
              scalable, visually appealing, and high-performance iOS
              applications.
            </Typography>
          </Grid>
        </Grid>

        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{
            flexWrap: "wrap",
            mt: { xs: 0, md: 5 },
            pl: { xs: 2, md: 0 },
            pr: { xs: 2, md: 0 },
          }}
        >
          {/* Left: Image */}

          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",

                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Highly Qualified iOS Training Team
            </Typography>
            <Typography variant="body1">
              Our team of certified iOS developers and trainers bring real-world
              expertise to the classroom. With years of experience working on
              top-tier apps, they offer insights, mentorship, and live code
              walkthroughs that ensure deep understanding.
            </Typography>
            <Typography variant="body1" sx={{ mt: 1 }}>
              Our team of certified iOS developers and trainers bring real-world
              expertise to the classroom. With years of experience working on
              top-tier apps, they offer insights, mentorship, and live code
              walkthroughs that ensure deep understanding.
            </Typography>
            <Typography variant="body1" sx={{ mt: 1 }}>
              Access our state-of-the-art training labs equipped with Mac
              systems and iOS testing devices. These labs are maintained to give
              you an experience similar to working in a tech company, enhancing
              your confidence and skill set.
            </Typography>
            <Typography variant="body1" sx={{ mt: 1 }}>
              We offer complete placement support to help you land your first
              iOS development job. Our career services include job matching,
              resume optimization, and interview coaching tailored to the needs
              of the tech industry.
            </Typography>
          </Grid>

          <Grid item sx={{ width: { xs: "100%", md: "25%" } }}>
            <img
              src={training}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>
        </Grid>
      </Box>
      <Footer />
    </Box>
  );
};

export default IOSTraining;
